import { MessageCircle } from "lucide-react";
import { whatsappLink } from "@/lib/api";

export default function FloatingWhatsApp() {
  return (
    <a
      href={whatsappLink("Hi, I'd like to know more about a project on Our First Realty.")}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-cta"
      className="fixed bottom-20 right-5 z-40 inline-flex items-center gap-2 rounded-full bg-whatsapp hover:brightness-95 text-white px-4 py-3 shadow-[0_12px_32px_rgba(37,211,102,0.35)] transition-all duration-300"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="text-sm font-medium hidden sm:inline">Chat on WhatsApp</span>
    </a>
  );
}
